import React from 'react';

export const Logo = ({ className = "h-12 w-12" }) => ( // Increased from h-8 w-8
  <svg 
    viewBox="0 0 100 100" 
    className={className}
    aria-label="Stack Track Logo"
  >
    {/* Up Arrow (Green) */}
    <path 
      d="M20 40 L50 10 L80 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="12"
      className="text-emerald-500"
    />
    {/* Down Arrow (Red) */}
    <path 
      d="M20 60 L50 90 L80 60"
      fill="none"
      stroke="currentColor"
      strokeWidth="12"
      className="text-red-500"
    />
  </svg>
); 